// extracted by mini-css-extract-plugin
module.exports = {"detailLevel":"Activities_detailLevel__3OHOe","activities":"Activities_activities__J_XwB"};